var meta={showLeftMenu:false,headIndex:1};
export var router = [{
	path: '/handOperatedProblem',
	meta:meta,
	name:'handOperatedProblem',
	component: resolve => require(["./handOperatedProblem.vue"],resolve)
}


]


// WEBPACK FOOTER //
// ./src/views/mycare/router.js